import React from 'react';
import PropTypes from 'prop-types';
import { regressionPages as regresionPageHelpers } from '../helpers';
import { ConditionalComponent } from '../Components';
import { Glyphicon, Tooltip, OverlayTrigger, Popover } from 'react-bootstrap';

const scenarioListItemComponent = ({
  actions, annotations, columns, detailsExpanded, hasDetails,
  onActionButtonClick, onExpandClick, scenario, showCommentHistory,
  jumpToScenario, pageType, productName
}) => {
  const cells = [];
  const iconStyle = {
    width: '32px',
    position: 'relative'
  };

  cells.push(<td style={iconStyle} key={-1}>
    {hasDetails ? (
      <Glyphicon onClick={onExpandClick}
        glyph={detailsExpanded ? 'chevron-down' : 'chevron-right'}
      />) : null} </td>);

  for (let columnIndex = 0; columnIndex < columns.length; columnIndex++) {
    const column = columns[columnIndex];
    if (!column.valueFunc) {
      continue;
    }

    // Get the value for the cell to display
    const value = column.valueFunc({ scenario, annotations, productName });

    if (column.valueType === regresionPageHelpers.COLUMN_TYPES.ACTIONABLE) {
      // If type is an action then save as Actions to be used as an element
      // ! This has to be capitalized for jsx to allow it below
      const Actions = value;

      cells.push(
        <td key={columnIndex}>
          <Actions
            actions={actions}
            onButtonClick={onActionButtonClick}
            itemId={scenario ? scenario.id : 0}
          />
        </td>
      );
    } else if (column.valueType === regresionPageHelpers.COLUMN_TYPES.ICON) {
      // icons are conditional, so cell value could be null
      if (!value) {
        cells.push(<td style={iconStyle} key={columnIndex}>{null}</td>);
        continue;
      }

      const glyphValue = value.glyph;

      // TODO can this tooltip portion use new tooltipFunc?
      // If the value is for an icon, then build a tooltip
      const tooltipText = value.glyph === 'remove' ?
        annotations.find(a => a.ticket !== null && a.ticket !== undefined) :
        value.title;

      const tooltip = (
        <Tooltip id="tooltip" style={{ width: 'auto' }}>
          {tooltipText}
        </Tooltip>
      );

      // if icon is meant to support a tooltip, then create it
      if (tooltip) {
        cells.push(
          <td style={iconStyle} key={columnIndex}>{ glyphValue && tooltip ?
            <OverlayTrigger overlay={tooltip} placement="top" delayShow={250} >
              { glyphValue === 'comment' ?
                <span role="button">
                  <Glyphicon glyph={glyphValue} onClick={showCommentHistory} />
                </span> :
                <Glyphicon glyph={glyphValue} />
              }
            </OverlayTrigger> :
            null }
          </td>
        );
      }
    } else if (column.valueType === regresionPageHelpers.COLUMN_TYPES.TEXT) {
      const colour = column.colourFunc ?
        column.colourFunc({
          numColumns: columns.length,
          columnIndex,
          scenario
        }) :
        '';

      cells.push(
        <td key={columnIndex}
          style={{
            color: colour,
            cursor: 'default'
          }}
          onClick={() => column.onClick && column.onClick({
            dispatchableAction: jumpToScenario,
            scenario,
            pageType
          })}
        >
          <ConditionalComponent
            condition={!!column.tooltipFunc}
            elseChildren={value}
          >
            <OverlayTrigger
              overlay={
                <Popover id={`popover-${columnIndex}`}>
                  {column.tooltipFunc && column.tooltipFunc({ scenario })}
                </Popover>
              }
            >
              <span>{value}</span>
            </OverlayTrigger>
          </ConditionalComponent>
        </td>);
    }
  }

  return (
    <tr>{cells}</tr>
  );
};

scenarioListItemComponent.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)).isRequired,
  annotations: PropTypes.array,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  detailsExpanded: PropTypes.bool,
  hasDetails: PropTypes.bool,
  onActionButtonClick: PropTypes.func.isRequired,
  onExpandClick: PropTypes.func,
  scenario: PropTypes.object.isRequired,
  showCommentHistory: PropTypes.func.isRequired,
  jumpToScenario: PropTypes.func.isRequired,
  pageType: PropTypes.object,
  productName: PropTypes.string
};

export default scenarioListItemComponent;


// WEBPACK FOOTER //
// src/Components/ScenarioListItemComponent.jsx